module.exports = __webpack_public_path__ + "static/img/315_TO8_2473_og.40829fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/315_TO8_2473_og.jpg
// module id = /gX2
// module chunks = 0